/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListEvents200ResponseDataInner
 */
export interface ListEvents200ResponseDataInner {
    /**
     * 
     * @type {number}
     * @memberof ListEvents200ResponseDataInner
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ListEvents200ResponseDataInner
     */
    organizerId?: number;
    /**
     * 
     * @type {string}
     * @memberof ListEvents200ResponseDataInner
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ListEvents200ResponseDataInner
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof ListEvents200ResponseDataInner
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ListEvents200ResponseDataInner
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ListEvents200ResponseDataInner
     */
    typeLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ListEvents200ResponseDataInner
     */
    startsAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ListEvents200ResponseDataInner
     */
    endsAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ListEvents200ResponseDataInner
     */
    locationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ListEvents200ResponseDataInner
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ListEvents200ResponseDataInner
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof ListEvents200ResponseDataInner
     */
    lat?: string;
    /**
     * 
     * @type {string}
     * @memberof ListEvents200ResponseDataInner
     */
    lng?: string;
    /**
     * 
     * @type {number}
     * @memberof ListEvents200ResponseDataInner
     */
    maxParticipants?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListEvents200ResponseDataInner
     */
    photoUrls?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ListEvents200ResponseDataInner
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ListEvents200ResponseDataInner
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the ListEvents200ResponseDataInner interface.
 */
export function instanceOfListEvents200ResponseDataInner(value: object): value is ListEvents200ResponseDataInner {
    return true;
}

export function ListEvents200ResponseDataInnerFromJSON(json: any): ListEvents200ResponseDataInner {
    return ListEvents200ResponseDataInnerFromJSONTyped(json, false);
}

export function ListEvents200ResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEvents200ResponseDataInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'organizerId': json['organizer_id'] == null ? undefined : json['organizer_id'],
        'title': json['title'] == null ? undefined : json['title'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'description': json['description'] == null ? undefined : json['description'],
        'type': json['type'] == null ? undefined : json['type'],
        'typeLabel': json['type_label'] == null ? undefined : json['type_label'],
        'startsAt': json['starts_at'] == null ? undefined : json['starts_at'],
        'endsAt': json['ends_at'] == null ? undefined : json['ends_at'],
        'locationName': json['location_name'] == null ? undefined : json['location_name'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'maxParticipants': json['max_participants'] == null ? undefined : json['max_participants'],
        'photoUrls': json['photo_urls'] == null ? undefined : json['photo_urls'],
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'updatedAt': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function ListEvents200ResponseDataInnerToJSON(json: any): ListEvents200ResponseDataInner {
    return ListEvents200ResponseDataInnerToJSONTyped(json, false);
}

export function ListEvents200ResponseDataInnerToJSONTyped(value?: ListEvents200ResponseDataInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organizer_id': value['organizerId'],
        'title': value['title'],
        'slug': value['slug'],
        'description': value['description'],
        'type': value['type'],
        'type_label': value['typeLabel'],
        'starts_at': value['startsAt'],
        'ends_at': value['endsAt'],
        'location_name': value['locationName'],
        'city': value['city'],
        'country': value['country'],
        'lat': value['lat'],
        'lng': value['lng'],
        'max_participants': value['maxParticipants'],
        'photo_urls': value['photoUrls'],
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
    };
}

